import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const getInitialTime = () => {
    const stored = localStorage.getItem('pzp_countdown_end');
    if (stored) {
      const end = parseInt(stored, 10);
      if (end > Date.now()) return end;
    }
    const newEnd = Date.now() + 24 * 60 * 60 * 1000; // 24h
    localStorage.setItem('pzp_countdown_end', String(newEnd));
    return newEnd;
  };
  const [endTime] = useState(getInitialTime);
  const [timeLeft, setTimeLeft] = useState(endTime - Date.now());
  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = endTime - Date.now();
      setTimeLeft(remaining > 0 ? remaining : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, [endTime]);
  const totalSeconds = Math.max(0, Math.floor(timeLeft / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="flex flex-col items-center gap-3 mb-6" data-id="element-37">
      <div className="flex items-center gap-2 text-brand-green font-body font-bold text-sm uppercase tracking-wider" data-id="element-38">
        <Clock className="w-4 h-4 animate-pulse" data-id="element-39" />
        <span data-id="element-40">Esta oferta termina en:</span>
      </div>
      <div className="flex items-center gap-2 md:gap-3" data-id="element-41">
        <TimeBox value={pad(hours)} label="Horas" data-id="element-42" />
        <span className="font-display text-2xl md:text-3xl text-brand-green" data-id="element-43">
          :
        </span>
        <TimeBox value={pad(minutes)} label="Min" data-id="element-44" />
        <span className="font-display text-2xl md:text-3xl text-brand-green" data-id="element-45">
          :
        </span>
        <TimeBox value={pad(seconds)} label="Seg" data-id="element-46" />
      </div>
    </div>;
}
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-47">
      <div className="bg-brand-black border border-brand-green/40 rounded-lg px-3 py-2 md:px-4 md:py-3 min-w-[58px] md:min-w-[68px]" data-id="element-48">
        <span className="font-display text-2xl md:text-3xl text-white tabular-nums" data-id="element-49">
          {value}
        </span>
      </div>
      <span className="font-body text-[10px] md:text-xs text-gray-500 mt-1 uppercase tracking-wider" data-id="element-50">
        {label}
      </span>
    </div>;
}